import React from "react";
import { Button, Popover, Position } from "@blueprintjs/core";
import styles from "./ThemeSettings.module.scss";
import { SketchPicker } from "react-color";
import { Icon } from "../../../atoms/Icon";

export function ColorPicker({ className, value, onChange, disabled = false }) {
  return (
    <Popover
      disabled={disabled}
      content={
        <SketchPicker color={value} onChange={(color) => onChange(color.hex)} />
      }
      className={className}
      position={Position.BOTTOM_LEFT}
    >
      <Button className={styles.colorPickerButton}>
        <div className={styles.colorPickerConatiner}>
          <div
            className={styles.colorPreview}
            style={{ backgroundColor: value }}
          ></div>
          <Icon name="caret-down" className={styles.colorIcon} />
        </div>
      </Button>
    </Popover>
  );
}
